// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prism-editor{padding:5px;color:#ccc;font-size:14px;font-family:Fira code,Fira Mono,Consolas,Menlo,Courier,monospace;line-height:1.5;background:#2d2d2d}.prism-editor__textarea:focus{outline:none}.preview{background-color:#ecfdf5}", ""]);
// Exports
module.exports = exports;
